// This filter just turns true values into "yes", and everything else to "no"

angular.module('wbFilters').filter('yesNo', () => (input) => {
  return input === true || input === "true" ? 'Yes' : 'No'
});
